import React from 'react'

export const signUpSignInState = {
  nameFirst: {
    touched: false,
    value: '',
    error: false,
    active: false,
  },
  nameLast: {
    touched: false,
    value: '',
    error: false,
    active: false,
  },
  phone: {
    touched: false,
    value: '',
    error: false,
    active: false,
  },
  email: {
    touched: false,
    value: '',
    error: false,
    active: false,
  },
  password: {
    touched: false,
    value: '',
    error: false,
    active: false,
  },
  showOTPInput: false,
  isOTPLogin: true,
  otp: Array(6).fill(''),
  otpActiveIdx: 0,
  accessTokens: [],
  selectedAccessToken: null,
  submitError: null,
  working: false
}

export const signUpSignInReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_TEXT':
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          value: action.value,
          error: false
        }
      }
    case 'FOCUS':
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          touched: true,
          active: true,
        }
      }
    case 'BLUR':
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          active: false
        }
      }
    case 'ERROR':
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          error: true,
          active: false
        }
      }
    case 'RESET_OTP_INPUT':
      return {
        ...state,
        showOTPInput: !state.showOTPInput,
        otp: Array(6).fill(''),
        otpActiveIdx: 0,
        submitError: null
      }
    case 'TOGGLE_OTP_INPUT':
      return {
        ...state,
        showOTPInput: !state.showOTPInput,
      }
    case 'TOGGLE_OTP_LOGIN':
      return {
        ...state,
        isOTPLogin: !state.isOTPLogin
      }
    case 'RESET_FORM':
      return {
        ...signUpSignInState
      }
    case 'SET_OTP':
      return {
        ...state,
        otp: action.otp,
        otpActiveIdx: action.otpActiveIdx
      }
    case 'SET_OTP_ACTIVE_IDX':
      return {
        ...state,
        otpActiveIdx: action.otpActiveIdx
      }
    case 'SET_ACCESS_TOKENS':
      return {
        ...state,
        accessTokens: action.accessTokens
      }
    case 'SET_SELECTED_ACCESS_TOKEN':
      return {
        ...state,
        selectedAccessToken: action.token
      }
    case 'SET_SUBMIT_ERROR':
      return {
        ...state,
        submitError: action.error
      }
    case 'SET_WORKING':
      return {
        ...state,
        working: action.working
      }
    default:
      return state
  }
}

export const AuthContext = React.createContext()
export const useAuthContext = () => React.useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(signUpSignInReducer, signUpSignInState)
  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  )
}
